"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Secure() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const processNotes = [{
    number: "01",
    label: "Submit Deal"
  }, {
    number: "02",
    label: "Underwrite"
  }, {
    number: "03",
    label: "Fund"
  }];
  return <section data-section-id="1488" id="secure-your-capital" className="relative overflow-hidden py-24 md:py-32 bg-background text-foreground" style={{
    backgroundColor: "hsl(222 47% 7%)"
  }}>
      {}
      <div aria-hidden="true" className="absolute top-0 left-0 right-0 flex items-center">
        <span className="inline-block size-1.5 rounded-lg ml-6 md:ml-12" style={{
        backgroundColor: "hsl(45 100% 50%)"
      }} />
        <span className="flex-1 h-px" style={{
        backgroundImage: "repeating-linear-gradient(to right, hsl(45 100% 50%) 0 6px, transparent 6px 11px)"
      }} />
        <span className="inline-block size-1.5 rounded-lg mr-6 md:mr-12" style={{
        backgroundColor: "hsl(45 100% 50%)"
      }} />
      </div>

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute -top-10 -right-10 w-72 h-72 opacity-60" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="hsl(222 47% 22%)" strokeWidth="1.5" strokeLinecap="round">
        <path d="M180 20 C 140 60, 110 100, 60 140" />
        <path d="M180 20 C 160 30, 145 50, 130 55" />
        <path d="M180 20 C 170 50, 165 75, 150 85" />
        <path d="M180 20 C 145 35, 120 60, 110 85" />
        <path d="M180 20 C 130 50, 100 90, 90 120" />
        <path d="M180 20 C 120 40, 80 80, 70 130" />
      </svg>

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute -bottom-10 -left-10 w-72 h-72 opacity-60 rotate-180" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="hsl(222 47% 22%)" strokeWidth="1.5" strokeLinecap="round">
        <path d="M180 20 C 140 60, 110 100, 60 140" />
        <path d="M180 20 C 160 30, 145 50, 130 55" />
        <path d="M180 20 C 170 50, 165 75, 150 85" />
        <path d="M180 20 C 145 35, 120 60, 110 85" />
        <path d="M180 20 C 130 50, 100 90, 90 120" />
        <path d="M180 20 C 120 40, 80 80, 70 130" />
      </svg>

      <div className="relative mx-auto max-w-[1320px] px-6 md:px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {}
          <div className="lg:col-span-8 order-2 lg:order-1">
            {}
            <div className="font-default text-xs font-medium uppercase mb-8 flex items-center gap-2" style={{
            color: "hsl(0 0% 100%)",
            letterSpacing: "0.16em"
          }}>
              <span style={{
              color: "hsl(45 100% 50%)"
            }}></span>
              <span>ENGINE 01 — CAPITAL SOLUTIONS</span>
            </div>

            {}
            <h2 className="font-default font-semibold mb-8" style={{
            color: "hsl(0 0% 100%)",
            fontSize: "clamp(2rem, 4.4vw, 3.75rem)",
            letterSpacing: "-0.02em",
            lineHeight: "1.06"
          }}>
              Capital Solutions, Engineered.
            </h2>

            {}
            <p className="max-w-2xl mb-10" style={{
            color: "hsl(215 20% 65%)",
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
            lineHeight: "1.55"
          }}>
              From first mortgage debt to second-position gap equity, we provide the infrastructure to close deals with little to none of your own cash. Fix-and-Flip, BRRRR, and new construction—architected for speed and scale.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button asChild className="rounded-lg h-12 px-7 font-semibold text-sm group" style={{
              backgroundColor: "hsl(45 100% 50%)",
              color: "hsl(222 47% 7%)",
              letterSpacing: "0.01em"
            }}>
                <Link to="/PreQualificationFormPage">
                  <span>Get Pre-Qualified</span>
                  <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="rounded-lg h-12 px-7 font-semibold text-sm bg-transparent border-[1.5px] hover:bg-[hsl(0_0%_100%)] hover:text-[hsl(222_47%_7%)] transition-colors duration-200" style={{
              borderColor: "hsl(215 20% 65%)",
              color: "hsl(0 0% 100%)",
              letterSpacing: "0.01em"
            }}>
                <Link to="/CapitalSolutionsPage">View Loan Programs</Link>
              </Button>
            </div>

            {}
            <div className="flex flex-col md:flex-row md:items-stretch gap-4 md:gap-0">
              {processNotes.map((note, i) => <div data-index={i} key={note.number} className="flex md:flex-1 items-center gap-4">
                  <div className="flex items-baseline gap-3 flex-1">
                    <span className="font-default text-xs font-medium" style={{
                  color: "hsl(45 100% 50%)",
                  letterSpacing: "0.16em"
                }}>
                      {note.number}
                    </span>
                    <span className="font-default text-base md:text-lg" style={{
                  color: "hsl(0 0% 100%)"
                }}>
                      {note.label}
                    </span>
                  </div>
                  {i < processNotes.length - 1 && <div aria-hidden="true" className="hidden md:flex items-center px-4">
                      <span className="inline-block w-8 h-px" style={{
                  backgroundImage: "repeating-linear-gradient(to right, hsl(215 20% 65% / 0.6) 0 6px, transparent 6px 11px)"
                }} />
                      <span className="inline-block size-1.5 rounded-lg ml-1" style={{
                  backgroundColor: "hsl(45 100% 50%)"
                }} />
                    </div>}
                </div>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-4 order-1 lg:order-2 relative">
            <div className="relative mx-auto max-w-md lg:max-w-none">
              {}
              <div aria-hidden="true" className="absolute -right-12 lg:-right-20 top-1/2 -translate-y-1/2 size-[280px] md:size-[360px] rounded-lg pointer-events-none" style={{
              backgroundColor: "hsl(222 47% 15%)",
              borderRadius: "0px"
            }} />

              {}
              <div className="relative aspect-[4/5] overflow-hidden rounded-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722377/img/real_estate_blueprint_vault.png" alt="Architectural blueprint of a real estate development project in a dark vault setting" loading="lazy" decoding="async" className="w-full h-full object-cover" />
              </div>

              {}
              <div className="absolute -top-4 -left-4 px-4 py-2 rounded-lg border-[1.5px] -rotate-3 hidden md:block" style={{
              backgroundColor: "hsl(0 0% 100%)",
              borderColor: "hsl(45 100% 50%)"
            }}>
                <span className="font-default italic text-sm" style={{
                color: "hsl(222 47% 7%)"
              }}>
                  professional-grade
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}